<template>
  <div v-if="isLoading" class="text-center">
    <p>Chargement en cours...</p>
  </div>
  <div v-else class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Modifier un parent</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="parentForm" @submit="editParent" :validation-schema="parentSchema" :initial-values="initialValues">
        <div class="row">
          <!-- Nom -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom du parent <span class="text-danger">*</span>
              </label>
              <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" />
              <ErrorMessage name="nom" class="text-danger" />
            </div>
          </div>

          <!-- Prénom -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Prénom du parent <span class="text-danger">*</span>
              </label>
              <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le prenom" />
              <ErrorMessage name="prenom" class="text-danger" />
            </div>
          </div>

          <!-- NPI -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Numéro NPI <span class="text-danger">*</span>
              </label>
              <Field name="npi" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le NPI" />
              <ErrorMessage name="npi" class="text-danger" />
            </div>
          </div>
          <!-- Email -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Email
              </label>
              <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer l'email" />
              <ErrorMessage name="email" class="text-danger" />
            </div>
          </div>

          <!-- Sexe -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Sexe <span class="text-danger">*</span>
              </label>
              <Field name="sexe" v-slot="{ field }">
                <Multiselect :options="['Masculin', 'Féminin']" :searchable="true" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner le sexe" />
              </Field>
              <ErrorMessage name="sexe" class="text-danger" />
            </div>
          </div>

          <!-- Téléphone 1 -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Téléphone 1 <span class="text-danger">*</span>
              </label>
              <Field name="telephone1" v-slot="{ field }">
                <vue-tel-input :value="field.value || ''" @input="field.onChange($event)" defaultCountry="BJ"
                  mode="international" @validate="validate" class="shadow-none fs-md-15 text-black py-2"
                  placeholder="Entrer le numéro de téléphone" />
              </Field>
              <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
              <ErrorMessage name="telephone1" class="text-danger" />
            </div>
          </div>

          <!-- Téléphone 2 -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Téléphone 2
              </label>
              <Field name="telephone2" v-slot="{ field }">
                <vue-tel-input :value="field.value || ''" @input="field.onChange($event)" defaultCountry="BJ"
                  mode="international" @validate="validate" class="shadow-none fs-md-15 text-black py-2"
                  placeholder="Entrer le numéro de téléphone" />
              </Field>
              <ErrorMessage name="telephone2" class="text-danger" />
            </div>
          </div>

          <!-- Date de naissance -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de naissance <span class="text-danger">*</span>
              </label>
              <Field name="dateNaissance" type="date" :max="currentDate"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateNaissance" class="text-danger" />
            </div>
          </div>

          <!-- Nationalité -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays de naissance <span class="text-danger">*</span>
              </label>
              <Field name="nationalite" v-slot="{ field }">
                <Multiselect :options="countries" :searchable="true" track-by="value" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le pays de naissance" />
              </Field>
              <ErrorMessage name="nationalite" class="text-danger" />
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button ref="submitButton" class="btn btn-success me-3" type="submit">
                Modifier le parent
              </button>
              <router-link to="/liste-parents" class="btn btn-danger">
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { useRouter, useRoute } from 'vue-router';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import { VueTelInput } from 'vue3-tel-input';
import { success, error } from '@/utils/utils';
import { countries } from '../../components/Inscription/countries';

export default defineComponent({
  name: 'EditParent',
  components: { Form, Field, ErrorMessage, Multiselect, VueTelInput },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(true);
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const validPhone = ref<boolean>(true);
    const parentForm = ref<any>(null); // Référence au composant Form
    const initialValues = ref<any>({}); // Valeurs initiales pour le formulaire
    const countriesRef = ref(countries);

    // Schéma de validation
    const parentSchema = Yup.object().shape({
      nom: Yup.string().required('Le nom du parent est obligatoire'),
      prenom: Yup.string().required('Le prénom du parent est obligatoire'),
      sexe: Yup.string().required('Le sexe est obligatoire'),
      npi: Yup.string()
        .matches(/^\d{10}$/, 'La saisie doit avoir exactement 10 chiffres')
        .required('Le numéro NPI est obligatoire'),
     
      email: Yup.string().email('Veuillez entrer un mail valide').nullable().notRequired(),
      telephone1: Yup.string().required('Le téléphone 1 est obligatoire'),
      telephone2: Yup.string().nullable().notRequired(),
      dateNaissance: Yup.date()
        .required('La date de naissance est obligatoire')
        .max(new Date(), 'La date de naissance ne peut pas être dans le futur')
        .test(
          'age-minimum',
          'Le parent doit avoir au moins 18 ans',
          function (value) {
            if (!value) return false;
            const today = new Date();
            const birthDate = new Date(value);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            return age >= 18;
          }
        ),
      nationalite: Yup.string().required('La nationalité est obligatoire'),
    });

    // Validation du téléphone
    const validate = (phoneObject: any) => {
      validPhone.value = phoneObject.valid ?? true;
    };

    // Récupérer les données du parent
    const getParent = async (id: number) => {
      try {
        const { data } = await ApiService.get(`/parents/${id}`);
        console.log('Données du parent:', data.data);

        // Préparer les valeurs initiales
        initialValues.value = {
          nom: data.data.nom || '',
          prenom: data.data.prenom || '',
          npi: data.data.npi || '',
          email: data.data.email || '',
          sexe: data.data.sexe || '',
          telephone1: data.data.telephone1 || '',
          telephone2: data.data.telephone2 || '',
          dateNaissance: data.data.dateNaissance ? data.data.dateNaissance.split('T')[0] : '',
          nationalite: data.data.nationalite || 'Bénin',
        };

        console.log('initialValues:', initialValues.value);
      } catch (err: any) {
        console.error('Erreur lors du chargement du parent:', err);
        error(err.response?.data?.message || 'Erreur lors du chargement du parent');
      } finally {
        isLoading.value = false;
      }
    };

    // Modifier le parent
    const editParent = async (values: any, { resetForm }: any) => {
      if (submitButton.value) submitButton.value.disabled = true;
      try {
        const id = route.params.id;
        console.log('Données envoyées:', values);
        const { data } = await ApiService.put(`/parents/${id}`, values);
        success(data.message);
        resetForm();
        router.push({ name: 'ListeParentPage' });
      } catch (err: any) {
        if (submitButton.value) submitButton.value.disabled = false;
        console.error('Erreur lors de la modification:', err);
        error(err.response?.data?.message || 'Erreur lors de la modification du parent');
      }
    };

    onMounted(async () => {
      isLoading.value = true;
      if (route.params.id) {
        await getParent(parseInt(route.params.id as string));
      }
      isLoading.value = false;
    });

    return {
      isLoading,
      parentForm,
      parentSchema,
      editParent,
      currentDate,
      submitButton,
      validate,
      countries: countriesRef,
      validPhone,
      initialValues,
    };
  },
});
</script>